import { PillSurface } from "./pill-button";

/**
 * 部屋タイプ一覧の「詳細・予約」/「満室」ピル（見た目のみ・非インタラクティブ）。
 * カード全体が button 化されたためクリックは親に委譲する。
 * - unavailable（空きなし）: disabled variant（淡色）+ 「満室」
 * - それ以外: solid + 「詳細・予約」
 * RoomTypeRow と SingleSelectionArchitecture の両方から使う。
 */
export function ReserveRoomTypePill({
  unavailable = false,
}: {
  unavailable?: boolean;
}) {
  if (unavailable) {
    return (
      <PillSurface variant="disabled" size="medium">
        満室
      </PillSurface>
    );
  }

  return (
    <PillSurface variant="solid" size="medium">
      詳細・予約
    </PillSurface>
  );
}
